<section class="flex flex-col gap-3.5 lg:max-h-40 xl:max-h-96 overflow-y-auto">
    <span class="text-base font-medium sticky top-0 bg-white z-10">{{
        'fieldInterventionInProgress' | transloco: { COUNT: totalFieldInterventionsCount() }
    }}</span>
    <div class="flex flex-col gap-1">
        @if (fieldInterventions()) {
            <ul class="flex flex-col list-none p-0 gap-1 m-0">
                @for (
                    fieldIntervention of (showAll() || totalFieldInterventionsCount() < minDisplay
                        ? fieldInterventions()
                        : fieldInterventions()!.slice(0, minDisplay)) ?? [];
                    track fieldIntervention.id
                ) {
                    <li>
                        <span class="text-base">{{ fieldIntervention.name }}</span>
                    </li>
                } @empty {
                    <li class="flex p-2">
                        <span>-</span>
                    </li>
                }
            </ul>

            @if (totalFieldInterventionsCount() > minDisplay) {
                <app-button
                    iconSize="xs"
                    [icon]="['fas', showAll() ? 'chevron-up' : 'chevron-down']"
                    [iconPosition]="IconPosition.END"
                    [label]="(showAll() ? 'displayLess' : 'displayMore') | transloco"
                    [type]="ButtonType.UNDERLINE"
                    (onClick)="toggleShow()" />
            }
        }
    </div>
</section>
